'use strict';
import $ from 'jquery';
import Swal from 'sweetalert2';

const challenge3 = {
  settings: {
    $form: $('.js-send-video'),
    $invalidFeedback: $('.invalid-feedback'),
    $inputVideo: $('input[name="video"]'),
  },

  resetInputVideo() {
    s.$inputVideo.val('');
  },

  sendVideo() {
    $('.js-send-video').on('submit', function (e) {
      e.preventDefault();

      s.$invalidFeedback.hide();

      $.ajax({
        type: 'POST',
        url: s.$form[0].action,
        data: s.$form.serialize(),
        dataType: 'json',
        success: function (response) {
          if (response.success) {
            Swal.fire({
              icon: 'success',
              title: response.success,
            }).then(() => {
              _this.resetInputVideo();
              window.location.reload();
            });
          } else {
            Swal.fire({
              icon: 'error',
              title: response.error,
            }).then(() => {
              _this.resetInputVideo();
            });
          }
        },
        error: function (response) {
          if (response.status === 422) {
            // Clear previous errors
            s.$invalidFeedback.html('');

            // Loop through each error and display it
            $.each(response.responseJSON.errors, function (field, messages) {
              s.$invalidFeedback.append(messages.join(', '));
            });

            s.$invalidFeedback.show();
          } else {
            // Handle other types of errors (e.g., 500 Internal Server Error)
            Swal.fire({
              icon: 'error',
              title: 'Erro ao enviar o vídeo. Por favor, tente novamente mais tarde.',
            });
          }
        }
      });
    });
  },
};

const _this = challenge3,
  s = _this.settings;

export default challenge3;